import React, { useEffect } from 'react';
import hotkeys, { KeyHandler } from 'hotkeys-js';

export interface Shortcut {
  id: string;
  code: string;
  alwaysShow?: boolean;
  action: KeyHandler;
  isAction?: boolean;
}

export default function decorateWithShortcut<P extends object>(
  WrappedComponent: React.FunctionComponent<P>,
  shortcuts: Shortcut[],
) {
  return function ComponentDecoratedWithTitle(props: P) {
    useEffect(() => {
      hotkeys.filter = () => true;
      shortcuts.forEach((obj) => {
        hotkeys(obj.code, obj.action.bind(obj));
      });

      return () => {
        shortcuts.forEach(({ code }) => {
          hotkeys.unbind(code);
        });
      };
    }, []);

    return <WrappedComponent {...props} />;
  };
}
